module.exports = __webpack_public_path__ + "assets/img/2.53f972fb.png";